import React, { useContext } from "react"

import { useEvent } from "shared/lib/useEvent"
import { useOverlays } from "shared/lib/useOverlays"

import { useOverlayActions } from "./useOverlayActions"

export const OverlayIDContext = React.createContext<string | null>(null)

export function useOverlayID(prefix?: string) {
  const overlayID = useContext(OverlayIDContext)

  return {
    containerID: overlayID ? `${prefix}-${overlayID}` : prefix,
    titleID: overlayID ? `${overlayID}-title` : prefix
  }
}

// Instance-scoped counterpart to useOverlay(TYPE): the stack is keyed by id, so
// only the id can express "close me" without also closing same-type siblings.
export function useCurrentOverlay() {
  const id = useContext(OverlayIDContext)
  const { closeOverlayByID } = useOverlayActions()
  const { currentOverlay } = useOverlays()

  const closeOverlay = useEvent(() => {
    closeOverlayByID({ id: id as string })
  })

  if (!id) {
    throw new Error("useCurrentOverlay must be called inside an overlay")
  }

  return { id, closeOverlay, isTopmost: currentOverlay?.id === id }
}
